const darkLimit = 30;
const lightLimit = 230;
const alphaLimit = 125;
export const rgbToHex = (rgb: [number, number, number]) =>
  `#${rgb
    .map((x) => {
      const hex = x.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    })
    .join("")}`;

const getImageData = (image: HTMLImageElement) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  if (!context) {
    return { data: [] };
  }
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  try {
    return context.getImageData(0, 0, canvas.width, canvas.height);
  } catch (e) {
    return { data: [] };
  }
};
export const detectColor = (
  image: HTMLImageElement,
  skip = 0,
  defaultColor = "white",
): string => {
  const { data } = getImageData(image);
  const colors: Record<string, number> = {};
  let primaryColor = defaultColor;
  let primaryColorLight = defaultColor;
  let maxCount = 0;
  let maxLightCount = 0;
  let alphaCount = 0;
  let checkedCount = 0;

  for (let px = 0; px < data.length; px += (skip + 1) * 4) {
    const r = data[px];
    const g = data[px + 1];
    const b = data[px + 2];
    const a = data[px + 3];
    const rgb = rgbToHex([r, g, b]);
    colors[rgb] = (colors[rgb] || 0) + 1;
    const isAlpha = typeof a !== "undefined" && a < alphaLimit;
    const isDark = r <= darkLimit && g <= darkLimit && b <= darkLimit;
    const isLight = r >= lightLimit && g >= lightLimit && b >= lightLimit;

    if (isAlpha) {
      alphaCount++;
    }
    if (colors[rgb] > maxCount && !isAlpha && !isDark) {
      primaryColor = rgb;
      maxCount = colors[rgb];
    }
    if (colors[rgb] > maxLightCount && !isAlpha && isLight) {
      primaryColorLight = rgb;
      maxLightCount = colors[rgb];
    }

    checkedCount++;
  }

  if (alphaCount / checkedCount >= 0.7) {
    return primaryColorLight;
  }
  return primaryColor;
};
